/**
 * Formats a number to 0,00 (fixed 2 decimals)
 */
export default (value, decimals = 2) =>
  value?.toLocaleString("da-DK", {
    maximumFractionDigits: decimals,
    minimumFractionDigits: decimals,
  }) || "";
